<template>
    <RowColumn type="none" class="bg-white rounded-shadow m-1">
        <div class="container pt-3">
            <div class="flex justify-between pt-2 items-center">
                <ButtonTag :is-tw-main-btn="true" :is-w100="false">
                    <router-link
                        class="pt-1 text-white text-decoration-none"
                        :to="$i18nHelper.getUrl('production/properties/add')"
                    >
                        {{ $t('add') }}
                    </router-link>
                </ButtonTag>
                <CurrencyCollapse :is-bg-white="false"></CurrencyCollapse>
            </div>
        </div>
        <div class="pt-5">
            <table class="w-full bg-white">
                <thead>
                <tr>
                    <th class="py-2 px-4 border-b-2 border-gray-200 bg-gray-100">#</th>
                    <th class="py-2 px-4 border-b-2 border-gray-200 bg-gray-100 hidden sm:table-cell">
                        {{ $t('image.title') }}
                    </th>
                    <th class="py-2 px-4 border-b-2 border-gray-200 bg-gray-100">{{ $t('name') }}</th>
                    <th class="py-2 px-4 border-b-2 border-gray-200 bg-gray-100 hidden md:table-cell">
                        {{ $t('category') }}
                    </th>
                    <th class="py-2 px-4 border-b-2 border-gray-200 bg-gray-100">
                        {{ $t('unitOfMeasure.short') }}
                    </th>
                    <th class="py-2 px-4 border-b-2 border-gray-200 bg-gray-100 hidden md:table-cell">
                        {{ $t('loss') }}
                    </th>
                    <th class="py-2 px-4 border-b-2 border-gray-200 bg-gray-100">
                        {{ $t('warehouse.residueInWarehouse') }}
                    </th>
                    <th class="py-2 px-4 border-b-2 border-gray-200 bg-gray-100">{{ $t('actions') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(product, index) in products" :key="index">
                    <td class="py-2 px-4">{{ index + 1 }}</td>
                    <td class="py-2 px-4 hidden sm:table-cell">
                        <img :src="product.img" alt="#" class="h-10 w-10 rounded-full">
                    </td>
                    <td class="py-2 px-4">{{ product.name }}</td>
                    <td class="py-2 px-4 hidden md:table-cell">{{ product.category }}</td>
                    <td class="py-2 px-4">{{ product.unitOfMeasure }}</td>
                    <td class="px-1 mx-1 text-left-5 text-redForLoss hidden md:table-cell">
                        <div v-for="(loss, index) in product.loss" :key="index" class="inline">
                            <label class="">{{ loss.lossInCleaning }}</label>
                            <label class="m-1">{{ loss.lossInCooking }}</label>
                            <label class="p-1">{{ loss.lossInProcessing }}</label>
                            <label class="p-1">{{ loss.lossInStorage }}</label>
                        </div>
                    </td>
                    <td class="py-2 px-4">{{ product.residueInWarehouse }}</td>
                    <td class="py-2 px-4">
                        <div class="actions-cell">
                            <img
                                src="/images/Pencil.svg"
                                alt="Tahrir"
                                class="h-7 cursor-pointer"
                            >
                            <img
                                src="/images/Remove.svg"
                                alt="O'chirish"
                                class="h-6 cursor-pointer"
                                @click="showRemoveModal(index)"
                            >
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <!-- Remove Modal -->
            <b-modal
                hide-footer
                id="remove-product-modal"
                v-model="isRemoveModalVisible"
                :title="$t('deleteConfirmSimple')"
            >
                <div class="text-center">
                    <div class="mt-4 gap-4">
                        <b-button variant="danger mr-4" @click="removeProduct">{{ $t("delete") }}</b-button>
                        <b-button variant="secondary" @click="closeRemoveModal">{{ $t("cancel") }}</b-button>
                    </div>
                </div>
            </b-modal>
        </div>
    </RowColumn>
</template>

<script>
import {mapActions} from "vuex";
import RowColumn from "@/components/RowColumn.vue";
import ButtonTag from "@/components/html/ButtonTag.vue";
import CurrencyCollapse from "@/components/CurrencyCollapse.vue";

export default {
    components: {CurrencyCollapse, ButtonTag, RowColumn},
    data() {
        return {
            isCollapsed: false,
            isRemoveModalVisible: false,
            selectedIndex: null,
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'production.properties.title'},

            ],
            products: [
                {
                    img: '/images/mayonez.jpg',
                    name: 'Sous mayonez',
                    category: 'Souslar',
                    unitOfMeasure: 'Karobka dona gr',
                    loss: [
                        {lossInCleaning: '5%'},
                        {lossInCooking: '13%'},
                        {lossInStorage: '9.8%'},
                        {lossInProcessing: '6.7%'}
                    ],
                    residueInWarehouse: '20 karobka 4 dona'
                },
                {
                    img: '/images/mayonez.jpg',
                    name: 'Sous mayonez',
                    category: 'Souslar',
                    unitOfMeasure: 'Karobka dona gr',
                    loss: [
                        {lossInCleaning: '5%'},
                        {lossInCooking: '13%'},
                        {lossInStorage: '9.8%'},
                        {lossInProcessing: '6.7%'}
                    ],
                    residueInWarehouse: '20 karobka 4 dona'
                },
            ],

        };
    },
    methods: {
        ...mapActions(['setBreadcrumbItems']),
        showRemoveModal(index) {
            this.selectedIndex = index
            this.isRemoveModalVisible = true
        },
        removeProduct() {
            if (this.selectedIndex !== null) {
                this.products.splice(this.selectedIndex, 1)
                this.closeRemoveModal()
            }
        },
        closeRemoveModal() {
            this.isRemoveModalVisible = false
            this.selectedIndex = null
        },
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
};
</script>

<style scoped>
.actions-cell {
    display: flex;
    align-items: center;
}

.actions-cell button {
    border: none;
    cursor: pointer;
    background-color: transparent;
}

tbody tr {
    border-bottom: 1px solid #e0e0e0;
}

</style>
